var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share",
    "data-name": "Icon feather-share",
    transform: "translate(-5 -2)",
    opacity: 0.894
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M20.613,29.438H8.088A3.091,3.091,0,0,1,5,26.35V18a1,1,0,0,1,2,0v8.35a1.089,1.089,0,0,0,1.088,1.088H20.613A1.089,1.089,0,0,0,21.7,26.35V18a1,1,0,1,1,2,0v8.35A3.091,3.091,0,0,1,20.613,29.438Z",
    transform: "translate(0 -4.562)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M20.35,8.175a1,1,0,0,1-.707-.293L16.175,4.414,12.707,7.882a1,1,0,0,1-1.414-1.414l4.175-4.175a1,1,0,0,1,1.414,0l4.175,4.175a1,1,0,0,1-.707,1.707Z",
    transform: "translate(-1.825 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M18,17.569a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V16.569A1,1,0,0,1,18,17.569Z",
    transform: "translate(-3.65 0)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.180741964ed3ef338c2a2ec620eab8c6.svg";
export { ForwardRef as ReactComponent };